import { render, staticRenderFns } from "./PatientExpantionAreas.vue?vue&type=template&id=7b510fda&scoped=true&"
import script from "./PatientExpantionAreas.vue?vue&type=script&lang=ts&"
export * from "./PatientExpantionAreas.vue?vue&type=script&lang=ts&"
import style0 from "./PatientExpantionAreas.vue?vue&type=style&index=0&id=7b510fda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b510fda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VForm,VRow})
